import { StyleSheet } from 'react-native';
import {
  BG_COLOR,
  BG_FORM_DEFAULT,
  COLOR_TEXT_DEFAULT,
  FONT_FAMILY_DEFAULT,
  FONT_SIZE_DEFAULT,
  INPUT_BG,
  LINE_COLOR,
} from '@assets/style/styleDefault';

const styles = StyleSheet.create({
  header: {
    height: '100%',
    flex: 1,
    backgroundColor: BG_COLOR,
    position: 'relative',
  },
  positionSticky: {
    position: 'sticky',
    top: 0,
    backgroundColor: BG_COLOR,
    zIndex: 10,
    marginRight: 15,
  },

  borderForm: {
    paddingTop: 10,
    paddingLeft: 20,
    paddingRight: '15vw',
    paddingBottom: 10,
    backgroundColor: BG_FORM_DEFAULT,
    minHeight: 1100,
    marginRight: 20,
    minWidth: 1000,
  },
  flexDirection: {
    flexDirection: 'row',
  },
  inputArea: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    // paddingHorizontal: 10,
  },
  titleInput: {
    fontFamily: FONT_FAMILY_DEFAULT,
    fontSize: FONT_SIZE_DEFAULT,
    display: 'flex',
    alignItems: 'center',
    height: 42,
    paddingLeft: 10,
  },
  whiteColor: {
    color: COLOR_TEXT_DEFAULT,
  },
  redColor: {
    color: 'red',
  },

  bulkhead: {
    borderColor: '#404040',
    borderWidth: '0.1px',
    marginBottom: 16,
  },
  minHeight: {
    minHeight: 'unset',
  },
  borderBottomWhite: {
    alignItems: 'center',
    paddingVertical: 5,
    borderBottomColor: LINE_COLOR,
    borderBottomWidth: 1,
  },
  margin12: { marginTop: 25 },
  marginBottom: {
    marginBottom: 100,
    paddingBottom: 120,
  },
  noteTextArea: {
    color: '#A5A5A5',
    lineHeight: '1.2',
    paddingBottom: '10px',
    minHeight: 250,
  },
  borderFormTextArea: {
    backgroundColor: INPUT_BG,
    borderRadius: '5px',
    paddingHorizontal: 10,
    paddingTop: 10,
  },
  inputTextArea: {},
  imgTextArea: {
    width: 18,
    height: 18,
  },
});

export default styles;
